import { asString, loadedDefinedMap, loadedDefinedMapWithDefault } from "common/components/component-helpers";
import { Data } from "common/components/data";
import type { AppEnvironment, AppOther } from "common/components/types";
import { LOADING, ActionSource } from "common/components/types";
import type { GlideFunctionalRenderer } from "common/components/uis";
import { evalSummary, isImageSourceEmpty } from "common/components/portable-renderers";
import Title, { TitleSkeleton } from "../ui/smart/title/title";
import { TitleAppearance } from "common/generator/components/title-style";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";
import type { ImageAspectRatio } from "common/generator/components/image-types";

export const TitleMaterialRenderer: GlideFunctionalRenderer = p => {
    // FIXME: subscribe to all the images

    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[titleValue, subtitleValue, imageValue, onTap, onDropImage, appearanceValue, aspectValue], [, , imageVP]] =
        useForceValueProducers(getValueProducers, force, ctx);
    const { onClick: onClickCB } = useOnClickFromAction(onTap, ActionSource.Summary, ctx, env);
    const { onClickWithCustomContext: onDropCB } = useOnClickFromAction(onDropImage, ActionSource.Summary, ctx, env);

    if (titleValue === LOADING && subtitleValue === LOADING && imageValue === LOADING) {
        return <TitleSkeleton />;
    }
    const { title, subtitle, imageSource } = evalSummary(titleValue, subtitleValue, imageVP, force);
    if (
        title === undefined &&
        subtitle === undefined &&
        (imageSource === undefined || isImageSourceEmpty(imageSource))
    ) {
        return null;
    }

    const onClick = onClickCB !== undefined ? () => onClickCB(undefined) : undefined;
    const onDrop =
        onDropCB !== undefined
            ? (img: string) => {
                  const { isBuilder } = env.appEnvironment;
                  if (!isBuilder) return;
                  return onDropCB(Data.fromJSON<AppOther, AppEnvironment>(img), undefined);
              }
            : undefined;

    const appearance = loadedDefinedMapWithDefault(
        appearanceValue,
        TitleAppearance.Filled,
        asString
    ) as TitleAppearance;

    const aspect = loadedDefinedMap(aspectValue, asString) as ImageAspectRatio | undefined;

    return (
        <Title
            appEnvironment={env.appEnvironment}
            title={title}
            subtitle={subtitle}
            imageSource={imageSource}
            onClick={onClick}
            onDropImage={onDrop}
            appearance={appearance}
            aspect={aspect}
        />
    );
};
